import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import useRules from "../../../../../hooks/useRules"

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '&>button:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const CustomersActionsButtons = () => {
  const history = useHistory();
  const classes = useStyles();
  const [rules,hasRule,isAdmin] = useRules();

  const handleClick = (role) => {
    history.push(`/protected/admin/users/add/${role}`);
  };

  return (
    <div className={classes.buttons}>
      {hasRule('users_add_customer') && <Button
        variant="contained"
        size="small"
        color="secondary"
        onClick={() => handleClick('customer')}
      >
        افزودن صاحب‌بار
      </Button>}
    </div>
  );
};

export default React.memo(CustomersActionsButtons);
